import { render } from "./AIRecordingHandoff.vue?vue&type=template&id=b97e5580&scoped=true&ts=true"
import script from "./AIRecordingHandoff.vue?vue&type=script&lang=ts"
export * from "./AIRecordingHandoff.vue?vue&type=script&lang=ts"

import "./AIRecordingHandoff.vue?vue&type=style&index=0&id=b97e5580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97e5580"]])

export default __exports__